import { Core } from '@pdftron/webviewer';

import { PartBotLocation } from '@frontend/api';

type Rect = {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
};

export const convertRectToPartBotLocation = (
  rect: Core.Math.Rect | Rect,
  pageHeight: number,
): PartBotLocation => {
  return [rect.x1, pageHeight - rect.y2, rect.x2, pageHeight - rect.y1];
};

export const arePartBotLocationsOverlapping = ({
  loc1,
  loc2,
  tolerance = 1.0,
}: {
  loc1: PartBotLocation;
  loc2: PartBotLocation;
  tolerance?: number;
}): boolean => {
  return (
    Math.abs(loc1[0] - loc2[0]) < tolerance &&
    Math.abs(loc1[1] - loc2[1]) < tolerance &&
    Math.abs(loc1[2] - loc2[2]) < tolerance &&
    Math.abs(loc1[3] - loc2[3]) < tolerance
  );
};
